import type { Resource } from '../lib/mockData';

interface ResourceCardProps {
  resource: Resource;
  onOpen: (resource: Resource) => void;
  isStudent?: boolean;
  onSubmitAssignment?: (assignment: Resource) => void;
}

export function ResourceCard({ resource, onOpen, isStudent = false, onSubmitAssignment }: ResourceCardProps) {
  const typeIcon = resource.type === 'textbook' ? '📖' : '✍️';
  const typeBg = resource.type === 'textbook' 
    ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300' 
    : 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300';

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200 dark:border-gray-700">
      <div className={`${typeBg} px-4 py-3 flex items-center space-x-2`}>
        <span className="text-2xl">{typeIcon}</span>
        <div className="flex-1">
          <h3 className="font-semibold text-sm uppercase tracking-wide">
            {resource.type}
          </h3>
          <p className="text-xs opacity-75">{resource.subject}</p>
        </div>
      </div>
      
      <div className="p-4">
        <h4 className="font-bold text-lg mb-2 text-gray-800 dark:text-white line-clamp-2">
          {resource.title}
        </h4>
        <p className="text-gray-600 dark:text-gray-400 text-sm mb-2 line-clamp-2">
          {resource.description}
        </p>

        {resource.teacherName && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
            👨‍🏫 {resource.teacherName}
          </p>
        )}
        
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500 dark:text-gray-400">
              📅 {new Date(resource.uploadedAt).toLocaleDateString()}
            </span>
          </div>

          <div className="flex gap-2">
            <button
              onClick={() => onOpen(resource)}
              className="flex-1 bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 text-sm"
            >
              {resource.type === 'textbook' ? 'Read' : 'View'}
            </button>

            {isStudent && resource.type === 'assignment' && onSubmitAssignment && (
              <button
                onClick={() => onSubmitAssignment(resource)}
                className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 text-sm"
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
